export default __webpack_public_path__ + "static/media/Christie.f736646b.jpg";